import { useIntl } from 'react-intl';

import { useLocaleState } from '@/hooks/store';

import messages from './messages';
import {
	Grid,
	HowToUseTitle,
	TextWrapper,
	TileImage,
	TileSubtitle,
	TileTitle,
	TileWrapper,
	Wrapper,
} from './styles';

const HowToUse = () => {
	const { formatMessage } = useIntl();
	const locale = useLocaleState();

	const tiles = [
		{
			src: '/_n/images/thomas/thomas-tile-1.webp',
			title: formatMessage(messages.skillTitle),
			subtitle: formatMessage(messages.skillSubtitle),
		},
		{
			src: '/_n/images/thomas/thomas-tile-2.webp',
			title: formatMessage(messages.breatheTitle),
			subtitle: formatMessage(messages.breatheSubtitle),
			englishOnly: true,
		},
		{
			src: '/_n/images/thomas/thomas-tile-3.webp',
			title: formatMessage(messages.driftTitle),
			subtitle: formatMessage(messages.driftSubtitle),
		},
		{
			src: '/_n/images/thomas/thomas-tile-4.webp',
			title: formatMessage(messages.listenTitle),
			subtitle: formatMessage(messages.listenSubtitle),
			englishOnly: true,
		},
		{
			src: '/_n/images/thomas/thomas-tile-5.webp',
			title: formatMessage(messages.walkingTitle),
			subtitle: formatMessage(messages.walkingSubtitle),
		},
		{
			src: '/_n/images/thomas/thomas-tile-6.webp',
			title: formatMessage(messages.whimsicalTitle),
			subtitle: formatMessage(messages.whimsicalSubtitle),
		},
	];

	return (
		<Wrapper>
			<Grid>
				<HowToUseTitle>{formatMessage(messages.howToUseTitle)}</HowToUseTitle>
				{tiles.map(({ title, subtitle, src, englishOnly }) => {
					if (locale !== 'en' && englishOnly) return null;
					return (
						<TileWrapper id={title} key={title}>
							<TileImage src={src} />
							<TextWrapper>
								<TileTitle>{title}</TileTitle>
								<TileSubtitle>{subtitle}</TileSubtitle>
							</TextWrapper>
						</TileWrapper>
					);
				})}
			</Grid>
		</Wrapper>
	);
};

export default HowToUse;
